import URL_ROUTE from '../constants/index';

class Api {

    async guardarFormWeb({colegio, estudiantes, modulos, mensaje, recaptcha}) {
        console.log({colegio, estudiantes, modulos, mensaje, recaptcha}, "data")
        const data = {colegio, estudiantes, modulos, mensaje, recaptcha}
        const query = await fetch(`${URL_ROUTE.GUARDARFORMWEB}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }

    async guardarCRMFormWeb({colegio, nombre, estudiantes, email, telefono, modulos, mensaje, recaptcha}) {
        const data = {colegio, nombre, estudiantes, email, telefono, modulos, mensaje, recaptcha}
        const query = await fetch(`${URL_ROUTE.GUARDARCRMFORMWEB}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return query
    }
}

export default new Api();
